module.exports = "<ion-toolbar>\r\n  <ion-title>{{title}}</ion-title>\r\n</ion-toolbar>\r\n"